module.exports = __webpack_public_path__ + "img/investment-plan-mobile@2x.43709e1d.webp";